import { LayoutDefault } from "components";
import { HEADER_DESKTOP_HEIGHT } from "config";
import useOffSetTop from "hooks/useOffSetTop";
import { About, Contact, Home, Portfolio, Service,Shuttle } from "pages";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ThemeProvider from "theme";
import "./App.css";

function App() {
  const isScrolling = useOffSetTop(HEADER_DESKTOP_HEIGHT);

  return (
    <BrowserRouter>
      <ThemeProvider>
        <LayoutDefault isScrolling={isScrolling}>
          <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="/about" element={<About />}></Route>
            <Route path="/contact" element={<Contact />}></Route>
            <Route path="/portfolio" element={<Portfolio />}></Route>
            <Route path="/service" element={<Service />}></Route>
            <Route path="/shuttle-privacy" element={<Shuttle />}></Route>
            <Route path="*" element={<Service />}></Route>
          </Routes>
        </LayoutDefault>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
